import React from 'react';
import IconBase from './Icon-base';
export default class Close extends React.Component {
    render() {
        return (
            <IconBase width="26" height="26" viewBox="0 0 26 26" {...this.props}>
                <g xmlns="http://www.w3.org/2000/svg">
                    <g>
                        <g>
                            <path d="M0.358,16.978C0.148,16.934,0,16.752,0,16.542c0-7.253,8.61-8.798,10.61-9.059V4.155     c0-0.164,0.09-0.314,0.235-0.393c0.147-0.076,0.321-0.065,0.456,0.024l9.202,6.194c0.121,0.082,0.194,0.218,0.194,0.369     c0,0.147-0.073,0.284-0.194,0.366l-9.197,6.193c-0.137,0.09-0.313,0.1-0.457,0.023c-0.146-0.078-0.236-0.229-0.236-0.394v-3.58     c-1.447,0.009-2.645,0.073-3.642,0.193c-4.785,0.567-6.064,3.44-6.116,3.563l0,0c-0.071,0.165-0.233,0.271-0.41,0.271     C0.415,16.986,0.385,16.984,0.358,16.978z" />
                        </g>
                    </g>
                </g>
            </IconBase>
        );
    }
}



// WEBPACK FOOTER //
// ./src/containers/PrivateArea/DocumentViewer/src/SVGIcons/Redo.js